import { GridColDef } from '@mui/x-data-grid';
import useTable from '../../../../components/table/useTable';
import { useNavigate } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import BaseTable from '../../../../components/table/BaseTable';
import CustomButton from '../../../../components/button/CustomButton';

const AdminSubscriptionProducts = () => {
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      field: 'sId',
      headerName: 'sId',
      editable: false,
      flex: 0.3,
      // renderCell: (params: GridRenderCellParams) => (
      //   <Typography
      //     sx={{
      //       fontSize: '0.875rem',
      //       fontWeight: 600,
      //     }}
      //   >
      //     {params.row.name}
      //   </Typography>
      // ),
    },
    {
      field: 'name',
      headerName: 'Name',
      editable: false,
      flex: 0.3,
    },
    {
      field: 'maxProjects',
      headerName: 'Max projects',
      editable: false,
      flex: 0.2,
    },
    {
      field: 'active',
      headerName: 'Active',
      editable: false,
      flex: 0.2,
      type: 'boolean',
    },
  ];

  const { resourceLimit, ...props } = useTable({
    resourceUrl: 'subscription-products',
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack direction="column" spacing={1}>
        <BaseTable
          numberOfRowsPerPage={resourceLimit}
          columns={columns}
          onRowClick={(params) => navigate(`${params.id}`)}
          withElements={{
            withTitle: 'Subscription products',
            withCta: <CustomButton onClick={() => navigate('./add')}>Add product</CustomButton>,
          }}
          getRowId={(row) => row.sId}
          {...props}
        />
      </Stack>
    </Box>
  );
};

export default AdminSubscriptionProducts;
